export default {
  path: '/v5/settings',
  name: 'V5_settings',
  component: () => import('./SettingsPage.vue'),
};
